<template>
  <div class="nao-encontrado">
    <header>
      <div class="logos">
        <div class="logo-ta-na-lei">
          <router-link :to="{ name: 'IndexLegislacao' }">
            <img
              src="../assets/images/logo_lei_branco.png"
              class="logo-tanalei"
              alt="Logo do Tá na Lei"
              title="Logo do Projeto Tá na Lei"
            />
            <img
              src="../assets/images/logo_horizontal_branco.png"
              class="logo-tanalei2"
              alt="Logo do Tá na Lei"
              title="Logo do Projeto Tá na Lei"
            />
          </router-link>
        </div>
        <div class="logo-casa-goias">
          <a href="http://www.casacivil.go.gov.br/">
            <img
              src="../assets/images/logo_casa_goias.svg"
              class="imagem-secretaria"
              alt="Logo da Casa Civil e Governo de Goiás Colorido"
              title="Logo da Casa Civil"
            />
          </a>
        </div>
      </div>
    </header>
    <div class="linha"></div>
    <div class="error">
      <img src="../assets/images/simbolo-erro.png" class="simbolo-erro" alt="simbolo de erro" />
      <div class="text">
        <h1>404</h1>
        <p class="descricao-mobile">
          A página que está tentando acessar
          <br />não existe, ou está fora do ar!
        </p>
        <div class="botao">
          <router-link :to="{ name: 'IndexLegislacao' }">Início</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NaoEncontrado",
  metaInfo() {
    return {
      title: "Página não encontrada - Tá na Lei",
      titleTemplate: null,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Página não encontrada",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "Página não encontrada",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Página não encontrada - Tá na Lei",
        },
        {
          vmid: "prerender-status-code",
          name: "prerender-status-code",
          content: "404",
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `${process.env.VUE_APP_BASE_URL}${this.$route.fullPath}`,
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg",
        },
        {
          vmid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg",
        },
        {
          vmid: "og:image:type",
          property: "og:image:type",
          content: "image/jpeg",
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          property: "twitter:image",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content: "Fique por dentro dos seus direitos",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: "Página não encontrada - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "twitter:site",
          name: "twitter:site",
          content: `${process.env.VUE_APP_BASE_URL}${this.$route.fullPath}`,
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          property: "twitter:card",
          content: "summary_large_image",
        },
        {
          vmid: "og:image:width",
          property: "og:image:width",
          content: "1201",
        },
        {
          vmid: "og:image:height",
          property: "og:image:height",
          content: "631",
        },
      ],
    };
  },
};
</script>